import React from "react";
import "../Terms/Terms.css"; // ✅ Reuse same CSS

const ReturnsRefundPolicy = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        {/* Header */}
        <div className="terms-header">
          <h1>Returns & Refund Policy</h1>
          <p className="terms-sub">
            At <span className="brand">Shawl Haus</span>, we value your
            trust and strive to provide high-quality handcrafted Punjabi shawls.
            Please read our Returns & Refund Policy carefully.
          </p>
        </div>

        {/* Cards */}
        <div className="terms-card">
          <h2>⚠️ All Sales Are Final</h2>
          <ul>
            <li>All purchases are final. We do not accept returns or exchanges.</li>
            <li>
              This includes custom, personalized, or standard items.
            </li>
            <li>
              The only exception is if there is a manufacturing or design error
              made by <span className="brand">Shawl Haus</span>. In such
              cases, we will work with you to resolve the issue.
            </li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>💰 Refunds & Fees</h2>
          <ul>
            <li>
              Shipping and delivery fees are non-refundable, even in cases of
              returns or exchanges.
            </li>
            <li>
              Free shipping promotions are not eligible for refund if an order
              is returned (even in the rare case of an error).
            </li>
            <li>
              Refunds (if applicable) will only be processed back to the
              original payment method used during checkout.
            </li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>🛃 International Orders</h2>
          <ul>
            <li>
              Any duties, customs fees, or local taxes are the responsibility of
              the buyer.
            </li>
            <li>
              In rare cases where a return is accepted due to a{" "}
              <span className="brand">Shawl Haus</span> error, any
              associated duties or fees remain the responsibility of the
              customer.
            </li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>📦 Delivery Issues</h2>
          <ul>
            <li>
              If your package is lost or arrives damaged, please contact us at{" "}
              <span className="brand">[support email/phone]</span> within 7 days
              of delivery.
            </li>
            <li>
              We will review the situation and assist where appropriate.
            </li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>❓ Questions</h2>
          <p>
            For any inquiries regarding returns, refunds, or product issues,
            please reach out to us at{" "}
            <span className="brand">[support email]</span>.
          </p>
        </div>

        {/* Footer */}
        <div className="terms-footer">
          <p>
            &copy; {new Date().getFullYear()}{" "}
            <span className="brand">Shawl Haus</span>. All rights
            reserved.
          </p>
          <p className="small">
            This Returns & Refund Policy is subject to change without notice.
            Please review it regularly for updates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReturnsRefundPolicy;
